<template>
	<el-container class="container txt-16" direction="vertical">
		<Header></Header>
		<el-main class="main">
			<router-view></router-view>
		</el-main>
		<Footer></Footer>
	</el-container>
</template>
<script>
import Header from '@/common/pc/Header.vue';
import Footer from '@/common/pc/Footer.vue';
export default {
	components: {
		Header,
		Footer
	},
	data() {
		return {}
	},
	mounted() { },
	beforeDestroy() { },
	methods: {}
}
</script>
<style lang="scss" scoped>
.container {
	background-color: #000;
	min-height: 100vh;
	padding-top: 60px;

	.main {
		// min-height: calc(100vh - 596px - 60px);
		min-height: 50vh;
		padding: 0px;
	}
}

// element tabs 样式覆盖
::v-deep .el-tabs__nav-wrap {
	.el-tabs__active-bar {
		background-color: #fff !important;
	}

	.el-tabs__item {
		color: #888 !important;
	}

	.is-active {
		color: #fff !important;
	}

	&:after {
		background-color: #232437 !important;
		height: 1px;
	}
}

// element input 样式覆盖
::v-deep .el-input {
	&.is-disabled {
		.el-input__inner {
			background-color: #f5f7fa00 !important;
			color: #ffffff !important;
			border: 1px solid #474d57;
		}
	}
}
</style>

<style lang="scss">
// element select 样式覆盖
.el-select-dropdown__item {
	&.hover {
		background-color: #f5f7fa47 !important;
		color: var(--color-txt1);
	}
}
</style>